<template>
  <div class="properties-centent kk-checkbox">
    <div class="properties-body" v-if="model && model.id !== ''">
      <a-form>
        <a-descriptions :column="2">
          <a-descriptions-item label="事件名称">
            {{model.name}}
          </a-descriptions-item>
          <a-descriptions-item label="序号">
            {{model.sortNum}}
          </a-descriptions-item>
        </a-descriptions>
      </a-form>
      <hr/>
      <CsimVisitUnSelectFormList @addFormListHandle="addFormListHandle" :existIdList="existIdList"></CsimVisitUnSelectFormList>
      <hr/>
      <CsimVisitSelectedFormList ref="csimVisitSelectedFormList" :formList="model.formList"></CsimVisitSelectedFormList>
    </div>
    <div v-else>
      <a-empty
        class="hint-box"
        description="请先选择周期"
      />
    </div>
  </div>
</template>
<script>

import CsimVisitUnSelectFormList from "./CsimVisitUnSelectFormList";
import CsimVisitSelectedFormList from "./CsimVisitSelectedFormList";

export default {
  name: "CsimVisitFormContent",
  components: {
    CsimVisitUnSelectFormList,
    CsimVisitSelectedFormList
  },
  props: {
    model: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    existIdList(){
      return this.model.formList.map(item=>item.formId)
    }
  },
  methods: {
    addFormListHandle(record){
      const that = this
      if(this.model.formList.filter(item=>item.formId===record.id).length>0){
        return this.$message.warning('重复添加')
      }
      record.sortNum = record.sortNum || 1
      this.model.formList.push({
        sortNum:1,
        formId:record.id,
        formName:record.name
      })
    },
  }
};
</script>
